export default __webpack_public_path__ + "static/realWorldImage3-eb3719ee045037004cd276358e463410.webp";